export const Gender = [
  {
    'label': 'Male',
    'value': 'Male'
  },
  {
    'label': 'Female',
    'value': 'Female'
  }
];